module.exports = __webpack_public_path__ + "static/media/md-backspace.78d27839.svg";